export const sampleProjects = [
  {
    id: 1,
    name: 'Riyadh Mall Construction',
    description: 'Modern shopping complex with 200+ retail stores, entertainment zones, and premium dining areas',
    status: 'In Progress',
    phase: 'Construction',
    progress: 75,
    budget: 2500000,
    spent: 1875000,
    team: 45,
    deadline: '2024-12-15',
    startDate: '2023-06-01',
    location: 'Riyadh, Saudi Arabia',
    priority: 'High',
    category: 'Commercial',
    tags: ['Retail', 'Entertainment', 'Premium'],
    milestones: [
      { id: 1, name: 'Site Preparation Complete', completed: true, date: '2023-08-15', description: 'Land clearing and foundation preparation' },
      { id: 2, name: 'Foundation Complete', completed: true, date: '2023-12-20', description: 'Structural foundation and underground parking' },
      { id: 3, name: 'Structure 50% Complete', completed: true, date: '2024-03-15', description: 'Main building structure halfway complete' },
      { id: 4, name: 'Interior Finishing', completed: false, date: '2024-09-30', description: 'Internal walls, flooring, and fixtures' },
      { id: 5, name: 'Final Inspection', completed: false, date: '2024-11-30', description: 'Quality assurance and safety checks' }
    ],
    teamMembers: [
      { id: 1, name: 'Ahmed Al-Rashid', role: 'Project Manager', avatar: 'AR', email: 'ahmed@company.com', phone: '+966-50-123-4567' },
      { id: 2, name: 'Sarah Johnson', role: 'Architect', avatar: 'SJ', email: 'sarah@company.com', phone: '+966-50-234-5678' },
      { id: 3, name: 'Mohammed Al-Zahrani', role: 'Site Engineer', avatar: 'MZ', email: 'mohammed@company.com', phone: '+966-50-345-6789' },
      { id: 4, name: 'Fatima Al-Qahtani', role: 'Quality Control', avatar: 'FQ', email: 'fatima@company.com', phone: '+966-50-456-7890' }
    ],
    risks: [
      { id: 1, level: 'Medium', description: 'Material delivery delays due to supply chain issues', mitigation: 'Alternative suppliers identified' },
      { id: 2, level: 'Low', description: 'Weather impact on construction schedule', mitigation: 'Indoor work prioritized during adverse weather' }
    ],
    documents: [
      { id: 1, name: 'Master Plan.pdf', type: 'pdf', size: '2.4 MB', uploadedBy: 'Ahmed Al-Rashid', uploadDate: '2023-05-15' },
      { id: 2, name: 'Structural Design.dwg', type: 'dwg', size: '15.7 MB', uploadedBy: 'Sarah Johnson', uploadDate: '2023-06-20' },
      { id: 3, name: 'Budget Analysis.xlsx', type: 'xlsx', size: '856 KB', uploadedBy: 'Ahmed Al-Rashid', uploadDate: '2023-07-10' }
    ],
    timeline: [
      { phase: 'Site Selection', startDate: '2023-01-01', endDate: '2023-03-31', progress: 100 },
      { phase: 'Design', startDate: '2023-04-01', endDate: '2023-05-31', progress: 100 },
      { phase: 'Construction', startDate: '2023-06-01', endDate: '2024-12-15', progress: 75 },
      { phase: 'Opening', startDate: '2024-12-16', endDate: '2025-01-31', progress: 0 }
    ]
  },
  {
    id: 2,
    name: 'Jeddah Office Complex',
    description: 'Premium office complex with 15 floors, modern amenities, and smart building technology',
    status: 'Planning',
    phase: 'Design',
    progress: 30,
    budget: 1800000,
    spent: 540000,
    team: 28,
    deadline: '2025-03-20',
    startDate: '2024-01-15',
    location: 'Jeddah, Saudi Arabia',
    priority: 'Medium',
    category: 'Commercial',
    tags: ['Office', 'Smart Building', 'Premium'],
    milestones: [
      { id: 1, name: 'Site Survey Complete', completed: true, date: '2024-02-15', description: 'Geological and environmental assessment' },
      { id: 2, name: 'Concept Design Approved', completed: true, date: '2024-03-30', description: 'Initial design concept and approval' },
      { id: 3, name: 'Detailed Design', completed: false, date: '2024-06-30', description: 'Complete architectural and engineering design' },
      { id: 4, name: 'Permit Approval', completed: false, date: '2024-08-31', description: 'Building permits and regulatory approvals' }
    ],
    teamMembers: [
      { id: 1, name: 'Omar Al-Sayed', role: 'Project Manager', avatar: 'OS', email: 'omar@company.com', phone: '+966-50-567-8901' },
      { id: 2, name: 'Layla Al-Mansouri', role: 'Lead Architect', avatar: 'LM', email: 'layla@company.com', phone: '+966-50-678-9012' },
      { id: 3, name: 'Khalid Al-Otaibi', role: 'Structural Engineer', avatar: 'KO', email: 'khalid@company.com', phone: '+966-50-789-0123' }
    ],
    risks: [
      { id: 1, level: 'High', description: 'Complex permit requirements for smart building features', mitigation: 'Early engagement with regulatory authorities' }
    ],
    documents: [
      { id: 1, name: 'Site Survey Report.pdf', type: 'pdf', size: '5.2 MB', uploadedBy: 'Omar Al-Sayed', uploadDate: '2024-02-20' },
      { id: 2, name: 'Concept Design.pptx', type: 'pptx', size: '12.8 MB', uploadedBy: 'Layla Al-Mansouri', uploadDate: '2024-04-05' }
    ],
    timeline: [
      { phase: 'Site Selection', startDate: '2023-11-01', endDate: '2024-01-14', progress: 100 },
      { phase: 'Design', startDate: '2024-01-15', endDate: '2024-08-31', progress: 30 },
      { phase: 'Construction', startDate: '2024-09-01', endDate: '2025-02-28', progress: 0 },
      { phase: 'Opening', startDate: '2025-03-01', endDate: '2025-03-20', progress: 0 }
    ]
  },
  {
    id: 3,
    name: 'Dammam Industrial Park',
    description: 'Large-scale industrial facility with manufacturing units and logistics center',
    status: 'Completed',
    phase: 'Opening',
    progress: 100,
    budget: 3200000,
    spent: 3200000,
    team: 62,
    deadline: '2024-08-30',
    startDate: '2022-03-01',
    location: 'Dammam, Saudi Arabia',
    priority: 'High',
    category: 'Industrial',
    tags: ['Manufacturing', 'Logistics', 'Industrial'],
    milestones: [
      { id: 1, name: 'Site Preparation', completed: true, date: '2022-05-15', description: 'Land clearing and infrastructure setup' },
      { id: 2, name: 'Foundation Complete', completed: true, date: '2022-09-30', description: 'All building foundations completed' },
      { id: 3, name: 'Structure Complete', completed: true, date: '2023-06-15', description: 'All buildings and structures completed' },
      { id: 4, name: 'Equipment Installation', completed: true, date: '2024-05-30', description: 'Manufacturing equipment installed and tested' },
      { id: 5, name: 'Final Inspection', completed: true, date: '2024-08-15', description: 'All inspections passed successfully' }
    ],
    teamMembers: [
      { id: 1, name: 'Abdullah Al-Rashid', role: 'Project Director', avatar: 'AR', email: 'abdullah@company.com', phone: '+966-50-890-1234' },
      { id: 2, name: 'Noura Al-Zahrani', role: 'Operations Manager', avatar: 'NZ', email: 'noura@company.com', phone: '+966-50-901-2345' },
      { id: 3, name: 'Yousef Al-Qahtani', role: 'Technical Lead', avatar: 'YQ', email: 'yousef@company.com', phone: '+966-50-012-3456' }
    ],
    risks: [],
    documents: [
      { id: 1, name: 'Final Inspection Report.pdf', type: 'pdf', size: '8.9 MB', uploadedBy: 'Abdullah Al-Rashid', uploadDate: '2024-08-20' },
      { id: 2, name: 'Equipment Manuals.zip', type: 'zip', size: '45.2 MB', uploadedBy: 'Yousef Al-Qahtani', uploadDate: '2024-08-25' }
    ],
    timeline: [
      { phase: 'Site Selection', startDate: '2021-09-01', endDate: '2022-02-28', progress: 100 },
      { phase: 'Design', startDate: '2022-01-01', endDate: '2022-02-28', progress: 100 },
      { phase: 'Construction', startDate: '2022-03-01', endDate: '2024-07-31', progress: 100 },
      { phase: 'Opening', startDate: '2024-08-01', endDate: '2024-08-30', progress: 100 }
    ]
  },
  {
    id: 4,
    name: 'Abha Resort Development',
    description: 'Luxury mountain resort with 150 rooms, spa facilities, and adventure activities',
    status: 'At Risk',
    phase: 'Construction',
    progress: 60,
    budget: 4200000,
    spent: 2520000,
    team: 38,
    deadline: '2025-01-15',
    startDate: '2023-09-01',
    location: 'Abha, Saudi Arabia',
    priority: 'High',
    category: 'Hospitality',
    tags: ['Resort', 'Luxury', 'Tourism'],
    milestones: [
      { id: 1, name: 'Site Preparation', completed: true, date: '2023-11-30', description: 'Mountain site preparation and access roads' },
      { id: 2, name: 'Foundation Complete', completed: true, date: '2024-02-28', description: 'All building foundations completed' },
      { id: 3, name: 'Main Structure', completed: false, date: '2024-08-31', description: 'Main resort building structure' },
      { id: 4, name: 'Interior Finishing', completed: false, date: '2024-12-31', description: 'Luxury interior finishing and amenities' }
    ],
    teamMembers: [
      { id: 1, name: 'Rania Al-Sulaiman', role: 'Project Manager', avatar: 'RS', email: 'rania@company.com', phone: '+966-50-123-7890' },
      { id: 2, name: 'Hassan Al-Mutairi', role: 'Site Engineer', avatar: 'HM', email: 'hassan@company.com', phone: '+966-50-234-8901' },
      { id: 3, name: 'Aisha Al-Dossary', role: 'Interior Designer', avatar: 'AD', email: 'aisha@company.com', phone: '+966-50-345-9012' }
    ],
    risks: [
      { id: 1, level: 'High', description: 'Weather delays affecting mountain construction', mitigation: 'Extended timeline and weather-resistant materials' },
      { id: 2, level: 'Medium', description: 'Material transport challenges in mountain terrain', mitigation: 'Local supplier partnerships and helicopter transport' }
    ],
    documents: [
      { id: 1, name: 'Environmental Impact Assessment.pdf', type: 'pdf', size: '12.3 MB', uploadedBy: 'Rania Al-Sulaiman', uploadDate: '2023-08-15' },
      { id: 2, name: 'Mountain Access Plan.pdf', type: 'pdf', size: '6.7 MB', uploadedBy: 'Hassan Al-Mutairi', uploadDate: '2023-09-20' }
    ],
    timeline: [
      { phase: 'Site Selection', startDate: '2023-03-01', endDate: '2023-08-31', progress: 100 },
      { phase: 'Design', startDate: '2023-06-01', endDate: '2023-08-31', progress: 100 },
      { phase: 'Construction', startDate: '2023-09-01', endDate: '2024-12-31', progress: 60 },
      { phase: 'Opening', startDate: '2025-01-01', endDate: '2025-01-15', progress: 0 }
    ]
  },
  {
    id: 5,
    name: 'Tabuk University Campus',
    description: 'Modern university campus with academic buildings, research facilities, and student housing',
    status: 'In Progress',
    phase: 'Site Selection',
    progress: 15,
    budget: 1500000,
    spent: 225000,
    team: 22,
    deadline: '2025-06-30',
    startDate: '2024-03-01',
    location: 'Tabuk, Saudi Arabia',
    priority: 'Medium',
    category: 'Educational',
    tags: ['Education', 'Research', 'Campus'],
    milestones: [
      { id: 1, name: 'Site Survey', completed: true, date: '2024-04-15', description: 'Comprehensive site analysis and planning' },
      { id: 2, name: 'Master Plan Approval', completed: false, date: '2024-07-31', description: 'Campus master plan and approval' },
      { id: 3, name: 'Design Development', completed: false, date: '2024-10-31', description: 'Detailed design for all buildings' }
    ],
    teamMembers: [
      { id: 1, name: 'Dr. Khalid Al-Malki', role: 'Project Director', avatar: 'KM', email: 'khalid@company.com', phone: '+966-50-456-0123' },
      { id: 2, name: 'Mariam Al-Harbi', role: 'Academic Planner', avatar: 'MH', email: 'mariam@company.com', phone: '+966-50-567-1234' },
      { id: 3, name: 'Faisal Al-Shammari', role: 'Infrastructure Engineer', avatar: 'FS', email: 'faisal@company.com', phone: '+966-50-678-2345' }
    ],
    risks: [
      { id: 1, level: 'Medium', description: 'Complex stakeholder requirements from multiple university departments', mitigation: 'Regular stakeholder meetings and requirement workshops' }
    ],
    documents: [
      { id: 1, name: 'Site Analysis Report.pdf', type: 'pdf', size: '18.5 MB', uploadedBy: 'Dr. Khalid Al-Malki', uploadDate: '2024-04-20' },
      { id: 2, name: 'Stakeholder Requirements.docx', type: 'docx', size: '2.1 MB', uploadedBy: 'Mariam Al-Harbi', uploadDate: '2024-05-10' }
    ],
    timeline: [
      { phase: 'Site Selection', startDate: '2024-03-01', endDate: '2024-07-31', progress: 15 },
      { phase: 'Design', startDate: '2024-08-01', endDate: '2024-12-31', progress: 0 },
      { phase: 'Construction', startDate: '2025-01-01', endDate: '2025-05-31', progress: 0 },
      { phase: 'Opening', startDate: '2025-06-01', endDate: '2025-06-30', progress: 0 }
    ]
  }
];

export const projectCategories = [
  { id: 'commercial', name: 'Commercial', color: 'bg-blue-500' },
  { id: 'residential', name: 'Residential', color: 'bg-green-500' },
  { id: 'industrial', name: 'Industrial', color: 'bg-orange-500' },
  { id: 'hospitality', name: 'Hospitality', color: 'bg-purple-500' },
  { id: 'educational', name: 'Educational', color: 'bg-indigo-500' },
  { id: 'healthcare', name: 'Healthcare', color: 'bg-red-500' },
  { id: 'infrastructure', name: 'Infrastructure', color: 'bg-gray-500' }
];

export const projectPhases = [
  { id: 'site-selection', name: 'Site Selection', color: 'bg-purple-500' },
  { id: 'design', name: 'Design', color: 'bg-blue-500' },
  { id: 'construction', name: 'Construction', color: 'bg-orange-500' },
  { id: 'opening', name: 'Opening', color: 'bg-green-500' }
];

export const projectStatuses = [
  { id: 'planning', name: 'Planning', color: 'bg-yellow-500' },
  { id: 'in-progress', name: 'In Progress', color: 'bg-blue-500' },
  { id: 'completed', name: 'Completed', color: 'bg-green-500' },
  { id: 'at-risk', name: 'At Risk', color: 'bg-red-500' },
  { id: 'on-hold', name: 'On Hold', color: 'bg-gray-500' }
];

export const projectPriorities = [
  { id: 'low', name: 'Low', color: 'bg-gray-500' },
  { id: 'medium', name: 'Medium', color: 'bg-yellow-500' },
  { id: 'high', name: 'High', color: 'bg-red-500' },
  { id: 'critical', name: 'Critical', color: 'bg-red-600' }
]; 